export const transactions = {
  index: {
    search_title: '履歴検索',
    transaction_date: '取引日',
    search_detail: '詳細検索',
    search_input_placeholder: '名前 or ニックネーム',
    type: {
      charge: 'チャージ',
      receipt: 'ココロン受取',
      present: 'プレゼントココロン'
    },
    cancel: '取消済'
  },
  id: '取引コード',
  detail_title: '取引詳細',
  detail_fields: {
    transaction_datetime: '取引日時',
    charge_amount: 'チャージ金額',
    company_name: '企業名',
    shop_name: '所属名',
    recipient: '受取者',
    sender: '送付者',
    present: '受取者',
    transaction_kokoron: '取引ココロン',
    transaction_kokoron_present: 'プレゼントココロン',
  },
  dialog: {
    confirm_cancel: {
      title: '以下の履歴を本当に取り消しますか？'
    },
    cancel_complete: {
      title: '該当履歴を取り消しました',
      notice: '取り消しに伴い、以下の処理を実行しました。'
    }
  },
  btn_label: {
    cancel: '取り消し',
    back: '一覧へ戻る',
    not_confirm_cancel: '取り消しせずに戻る',
    cancel_dialog: '取り消す'
  },
  is_cancelled: '【取消済】'
}
